import api from './base'

export const apiClient = api
